import { Navigate } from "react-router-dom";
import LoadingSpinner from "../ui/LoadingSpinner";
import { useAuth } from "./AuthProvider";

type GuestOnlyRouteProps = {
  children: React.ReactNode;
}

const GuestOnlyRoute = ({ children }: GuestOnlyRouteProps) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    const raw = new URLSearchParams(window.location.search).get("redirectTo");
    // Only allow internal paths — never an absolute or protocol-relative URL.
    const isInternal = !!raw && raw.startsWith("/") && !raw.startsWith("//");
    return <Navigate to={isInternal ? raw! : "/"} replace />;
  }

  return <>{children}</>;
};

export default GuestOnlyRoute;